import { useBalances } from "../state/balances.js";
import { useUnits } from "../units/state.js";
import { useWorld } from "./state.js";

/**
 * Fuel (stamina) lives in three client stores: the balances, the map's `me` and the missions state. A refill — from the
 * fuel sheet, the storage or the store — only updated the balances, so the map chip, march buttons and missions kept the
 * old value until their next poll or a hard refresh (user 24.09.2026, D124). Any change of the balance now makes the
 * loaded views re-read theirs, debounced so a burst of pushes costs one request each.
 */
export function syncStamina(delayMs = 250): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const off = useBalances.subscribe((state, previous) => {
    const now = state.balances?.stamina, before = previous.balances?.stamina;
    if (now === undefined || before === undefined || now === before) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (useWorld.getState().me) void useWorld.getState().refreshMe();
      if (useUnits.getState().expeditions) void useUnits.getState().refreshExpeditions();
    }, delayMs);
  });
  return () => { off(); if (timer) clearTimeout(timer); };
}
